import { Center, Title } from "@mantine/core"
import { useLocation } from "@tanstack/react-router"
import { useEffect } from "react"
import { useTranslation } from "react-i18next"
import { Page } from "./-components/Page"
import { router } from "./router"

// For client side links that changed but are likely used outside
// of our control (e.g. from emails or bookmarks) provide redirects so
// old links still work.
type Redirect = { from: RegExp; to: (match: RegExpMatchArray) => string }
const redirectMap: Redirect[] = [
  {
    from: /^\/app\/absences\/my-absences\/(\d+)/,
    to: (match: RegExpMatchArray) => `/app/my/absences/${match[1]}`,
  },
  {
    from: /^\/app\/absences\/leave-requests\/(\d+)/,
    to: (match: RegExpMatchArray) => `/app/duties/leave-requests/${match[1]}`,
  },
]

export function NotFoundAndLegacyRedirect() {
  const { pathname } = useLocation()
  const { t } = useTranslation()
  useEffect(() => {
    for (let index = 0; index < redirectMap.length; index++) {
      const redirect = redirectMap[index]
      const match = pathname.match(redirect.from)
      if (match) {
        router.navigate({
          to: redirect.to(match),
          replace: true,
        })
        return
      }
    }
  }, [pathname, router])
  return (
    <Page>
      <Center w="100%" h="100%">
        <Title order={4}>{t("PageNotFound")}</Title>
      </Center>
    </Page>
  )
}
